import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhone = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeMiterlimit: 1.414,
		strokeWidth: 1.5,
		d: "M6.015 2.015a.906.906 0 0 0-.64-.265A3.625 3.625 0 0 0 1.75 5.375v1.71c0 1.094.264 2.172.768 3.143a17.033 17.033 0 0 0 7.254 7.254c.971.504 2.05.768 3.144.768h2.48a2.854 2.854 0 0 0 2.854-2.854 2.14 2.14 0 0 0-.953-1.782c-.314-.209-1.637-1.09-1.806-1.133a1.002 1.002 0 0 0-.482 0c-.169.042-1.612 1.07-2.065 1.271a2 2 0 0 1-1.435.073c-.162-.053-1.135-.497-1.791-.935-1.198-.8-1.82-1.402-2.608-2.608A11.039 11.039 0 0 1 6.327 8.8c-.195-.541-.122-1.342.283-1.881.406-.54 1.603-1.63 1.677-1.859a1 1 0 0 0 0-.618c-.052-.161-2.272-2.426-2.272-2.426Z"
	})]
});
const ForwardRef = forwardRef(SvgPhone);
export { ForwardRef as ReactComponent };
